module.exports = __webpack_public_path__ + "img/news.032d8d35.png";